import Vue from 'vue'
import Vuex from 'vuex'
import cache from '@/common/cache.js'
Vue.use(Vuex)

const state = {
  adminInfo: null,
  identityInfo: {},
  userType: 1,
  //  存放用户信息
  userInfo: {}
}

const getters = {
  getUserType: state => {
    state.userType = parseInt(cache.getUserType())
    return state.userType
  }
}

const mutations = {
  saveAdminInfo (state, adminInfo) {
    state.adminInfo = adminInfo
  },
  setUserType (state, type) {
    state.userType = type
    cache.saveUserType(type)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js